import "antd/dist/antd.css";
import { Table } from "antd";
import NavBar from "../NavBar/navbar";
import { Form as FormR } from "react-bootstrap";
import "./home.css";
import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import { Form, Input } from "antd";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { SearchOutlined } from "@ant-design/icons";
import { useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { toast, ToastContainer } from "react-toastify";
import { Tooltip } from "antd";
import { canAccessPage, getTokenUser } from "../../helper/token";
import AxiosHelper from "../../helper/axios-helper";
import VendorImg from "../../assets/Vendor.png";

function Home() {
  //#region StateManagement
  const [shouldLogIn] = useState(false);
  const tooltipColour = "#274D68";
  const [loggedInUser] = useState(getTokenUser());
  axios.defaults.headers.common["Authorization"] =
    loggedInUser == null ? "" : loggedInUser.token;

  const [showtable, setShowTable] = useState(0);
  const [tableDataSource, setDataSource] = useState([]);
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [tableSize] = useState("col-12");
  const [selectedDocumentLink, setSelectedDocumentLink] = useState("");
  const [newSelectedDocumentLink, setNewSelectedDocumentLink] = useState("");

  const navigate = useNavigate();

  const [customerProposalFilterValue] = useState(false);

  const [frequencyTypes, setFrequencyTypes] = useState([]);
  const [proposalFilters, setProposalFilters] = useState([]);
  const [statusFilters, setStatusFileters] = useState([]);
  const [cancelModalShow, setCancelModalShow] = useState(false);

  const [deleteProposalModalShow, setDeleteProposalModalShow] = useState(false);
  const [selectedDeleteProposal, setSelectedDeleteProposal] = useState("");
  const [editDocumentLinkShow, setEditDocumentLinkShow] = useState(false);

  const [editNotesShow, setEditNotesShow] = useState(false);
  const [selectedNotes, setSelectedNotes] = useState("");
  const [newSelectedNotes, setNewSelectedNotes] = useState("");

  const [pageSize, setPageSize] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  //#endregion

  const [proposalSelectedFilters, setProposalSelectedFilters] = useState([]);

  //#region Ant Table States & Functions

  const [editedValues] = useState({});

  const [statusSelectedFilters, setStatusSelectedFilters] = useState([
    "In Progress",
    "Planned",
  ]);
  const [customerSelectedFilters, setCustomerSelectedFilters] = useState([]);
  const [customerFilters, setCustomerFilters] = useState([]);

  const EditableContext = React.createContext(null);

  const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
      <Form form={form} component={false}>
        <EditableContext.Provider value={form}>
          <tr {...props} />
        </EditableContext.Provider>
      </Form>
    );
  };

  const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    ...restProps
  }) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    const form = useContext(EditableContext);

    useEffect(() => {
      if (editing) {
        inputRef.current.focus();
      }
    }, [editing]);

    const toggleEdit = () => {
      setEditing(!editing);
      form.setFieldsValue({
        [dataIndex]: record[dataIndex],
      });
    };

    const save = async () => {
      try {
        const values = await form.validateFields();
        toggleEdit();
        onTableDataChange(true);
        handleSave({
          ...record,
          ...values,
        });
      } catch (errInfo) {
        console.log("Save failed: ", errInfo);
      }
    };
    let childNode = children;
    if (editable) {
      childNode = editing ? (
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
          rules={[
            {
              required: true,
              message: `${title} is required.`,
            },
          ]}
        >
          <Input ref={inputRef} onPressEnter={save} onBlur={save} />
        </Form.Item>
      ) : (
        <div
          className="editable-cell-value-wrap"
          style={{
            paddingRight: 24,
          }}
          onClick={toggleEdit}
        >
          {children}
        </div>
      );
    }
    return <td {...restProps}>{childNode}</td>;
  };

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };

  //#endregion

  //#region Table column definitions

  const ProposalColumns = [
    {
      title: "Customer",
      dataIndex: "proposal_customer",
      filters: customerFilters,
      filterSearch: true,
      filteredValue: customerSelectedFilters,
      onFilter: (value, record) => record.proposal_customer.startsWith(value),
      filterIcon: (filtered) => (
        <SearchOutlined
          style={{ color: filtered ? "blue" : "#000000", fontSize: "16px" }}
        />
      ),
      render: (text, record, index) => {
        let isValid = true;
        if (record.proposal_customer === "-") {
          isValid = false;
        }
        return (
          <div
            className="dropdown"
            style={{ width: "105px", display: "flex", position: "relative" }}
          >
            {!isValid && (
              <Tooltip
                title="Please select a customer. Can't be '-'."
                color="#f88d8d"
              >
                <p className={"exclamation"}>!</p>
              </Tooltip>
            )}
            <Tooltip title={record.proposal_customer} color={tooltipColour}>
              <FormR.Select
                size="sm"
                defaultValue={record.proposal_customer}
                onChange={(e) => handleProposalCustomerChange(e, record)}
                className={`${!isValid ? "invalid-cell" : ""}`}
              >
                {dropdownOptions.map((x) => (
                  <option value={x.name}>{x.name}</option>
                ))}
              </FormR.Select>
            </Tooltip>
          </div>
        );
      },
    },
    {
      title: "Proposal Name",
      dataIndex: "proposal_name",
      filters: proposalFilters,
      filterSearch: true,
      filteredValue: proposalSelectedFilters,
      onFilter: (value, record) => record.proposal_name.startsWith(value),
      filterIcon: (filtered) => (
        <SearchOutlined
          style={{ color: filtered ? "blue" : "#000000", fontSize: "16px" }}
        />
      ),
      render: (text, record, index) => {
        let isValid = true;

        if (record.proposal_name === "-") {
          isValid = false;
        }

        return (
          <div style={{ display: "flex", position: "relative" }}>
            {!isValid && (
              <Tooltip
                title="Proposal name can't be empty or '-'."
                color="#f88d8d"
              >
                <p className={"exclamation"}>!</p>
              </Tooltip>
            )}
            <Tooltip
              title={record.proposal_name + " - " + record.key}
              color={tooltipColour}
            >
              <FormR.Control
                className={`editable-cell-input ${
                  !isValid ? "invalid-cell" : ""
                }`}
                size="sm"
                type="text"
                defaultValue={record.proposal_name}
                onBlur={(e) => handleProposalNameChange(e, record)}
              ></FormR.Control>
            </Tooltip>
          </div>
        );
      },
    },
    {
      title: "Date From",
      dataIndex: "proposal_date_from",
      render: (text, record, index) => {
        let isValid = true;

        if (record.proposal_date_from === "-") {
          isValid = false;
        }

        return (
          <div
            style={{ display: "flex", position: "relative", maxWidth: "80px" }}
          >
            {!isValid && (
              <Tooltip
                title="Please select a date from, can't be empty."
                color="#f88d8d"
              >
                <p className={"exclamation"}>!</p>
              </Tooltip>
            )}
            <FormR.Control
              className={`editable-cell-input ${
                !isValid ? "invalid-cell" : ""
              }`}
              size="sm"
              type="date"
              disabled={!record.proposal_date_from}
              defaultValue={record.proposal_date_from}
              onBlur={(e) => handleProposalDateFromChange(e, record)}
              style={{ maxWidth: "100px" }}
            ></FormR.Control>
          </div>
        );
      },
    },
    {
      title: "Date To",
      dataIndex: "proposal_date_to",
      render: (text, record, index) => {
        let isValid = true;

        if (record.proposal_date_to === "-") {
          isValid = false;
        }

        return (
          <div
            style={{ display: "flex", position: "relative", maxWidth: "80px" }}
          >
            {!isValid && (
              <Tooltip
                title="Please select a date to, can't be empty."
                color="#f88d8d"
              >
                <p className={"exclamation"}>!</p>
              </Tooltip>
            )}
            <FormR.Control
              className={`editable-cell-input ${
                !isValid ? "invalid-cell" : ""
              }`}
              size="sm"
              type="date"
              disabled={!record.proposal_date_to}
              defaultValue={record.proposal_date_to}
              onBlur={(e) => handleProposalDateToChange(e, record)}
              style={{ maxWidth: "100px" }}
            ></FormR.Control>
          </div>
        );
      },
    },
    {
      title: "Unit QTY",
      dataIndex: "proposal_unit_qty",
      render: (text, record, index) => {
        let isValid = true;

        if (parseInt(record.proposal_unit_qty) <= 0) {
          isValid = false;
        }

        return (
          <div
            style={{ maxWidth: "80px", display: "flex", position: "relative" }}
          >
            {!isValid && (
              <Tooltip title="Unit QTY can't be neagtive or 0." color="#f88d8d">
                <p className={"exclamation"}>!</p>
              </Tooltip>
            )}
            <FormR.Control
              className={`editable-cell-input ${
                !isValid ? "invalid-cell" : ""
              }`}
              size="sm"
              type="number"
              defaultValue={record.proposal_unit_qty}
              onBlur={(e) => handleProposalUnitQtyChange(e, record)}
              style={{ minWidth: "55px" }}
            ></FormR.Control>
          </div>
        );
      },
    },
    {
      title: "Unit Value",
      dataIndex: "proposal_unit_value",
      render: (text, record, index) => {
        let isValid = true;

        if (parseFloat(record.proposal_unit_value) <= 0) {
          isValid = false;
        }

        return (
          <div
            style={{ minWidth: "75px", display: "flex", position: "relative" }}
          >
            {!isValid && (
              <Tooltip
                title="Unit Value can't be neagtive or 0."
                color="#f88d8d"
              >
                <p className={"exclamation"}>!</p>
              </Tooltip>
            )}
            <FormR.Control
              className={`editable-cell-input ${
                !isValid ? "invalid-cell" : ""
              }`}
              size="sm"
              type="text"
              defaultValue={record.proposal_unit_value
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              onBlur={(e) => handleProposalUnitValueChange(e, record)}
              style={{ maxWidth: "75px" }}
            ></FormR.Control>
          </div>
        );
      },
    },
    {
      title: "SubTotal Exc",
      dataIndex: "proposal_subtotal_exc",
      render(text, record, index) {
        return {
          props: {
            style: { background: "#fafafa" },
          },
          children: (
            <div>
              <p className="non-editable-cell">
                {record.proposal_subtotal_exc
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              </p>
            </div>
          ),
        };
      },
    },
    {
      title: "Frequency QTY",
      dataIndex: "proposal_frequency_qty",
      render: (text, record, index) => {
        let isValid = true;

        if (parseInt(record.proposal_frequency_qty) <= 0) {
          isValid = false;
        }

        return (
          <div
            style={{ maxWidth: "80px", display: "flex", position: "relative" }}
          >
            {!isValid && (
              <Tooltip
                title="Frequency QTY can't be neagtive or 0."
                color="#f88d8d"
              >
                <p className={"exclamation"}>!</p>
              </Tooltip>
            )}
            <FormR.Control
              className={`editable-cell-input ${
                !isValid ? "invalid-cell" : ""
              }`}
              size="sm"
              type="number"
              defaultValue={record.proposal_frequency_qty}
              onBlur={(e) => handleProposalFrequencyQty(e, record)}
              style={{ maxWidth: "95px" }}
            ></FormR.Control>
          </div>
        );
      },
    },
    {
      title: "Frequency Type",
      dataIndex: "proposal_frequency_type",
      render: (text, record, index) => {
        let isValid = true;
        if (
          editedValues[record.key] !== undefined &&
          editedValues[record.key].proposal_frequency_type !== undefined
        ) {
          isValid = editedValues[record.key].proposal_frequency_type;
        } else {
          isValid = true;
        }

        return (
          <div className="dropdown" style={{ width: "80px" }}>
            <Tooltip
              title={record.proposal_frequency_type}
              color={tooltipColour}
            >
              <FormR.Select
                size="sm"
                defaultValue={record.proposal_frequency_type}
                onChange={(e) => handleProposalFrequencyTypeChange(e, record)}
                className={`${!isValid ? "invalid-cell" : ""}`}
              >
                {frequencyTypes.map((x) => (
                  <option value={x.value}>{x.value}</option>
                ))}
              </FormR.Select>
            </Tooltip>
          </div>
        );
      },
    },
    {
      title: "Total Exc",
      dataIndex: "proposal_total_exc",
      render(text, record, index) {
        return {
          props: {
            style: { background: "#fafafa" },
          },
          children: (
            <div>
              <p className="non-editable-cell">
                {record.proposal_total_exc
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              </p>
            </div>
          ),
        };
      },
    },
    {
      title: "Document",
      dataIndex: "proposal_file",
      render: (text, record, index) => (
        <div style={{ display: "flex" }}>
          {record.proposal_file === "" ||
          record.proposal_file === null ||
          record.proposal_file === "-" ? (
            <p className="non-editable-cell">No File</p>
          ) : (
            <a
              className="non-editable-cell"
              href={record.proposal_file}
              rel="noreferrer"
              target="_blank"
            >
              View
            </a>
          )}
          <Tooltip title={"Edit Link"} color={tooltipColour}>
            <img
              className="pencil-icon"
              src={require("./pencil.png")}
              alt="Not Found!"
              onClick={() => onEditDocumentLink(record)}
            />
          </Tooltip>
        </div>
      ),
    },
    {
      title: "Notes",
      dataIndex: "proposal_notes",
      render: (text, record, index) => (
        <div style={{ display: "flex" }}>
          <Button size="sm" onClick={() => onEditNotes(record)}>
            Notes
          </Button>
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "proposal_status",
      filters: statusFilters,
      filterSearch: true,
      filteredValue: statusSelectedFilters,
      onFilter: (value, record) => record.proposal_status.startsWith(value),
      filterIcon: (filtered) => (
        <SearchOutlined
          style={{ color: filtered ? "blue" : "#000000", fontSize: "16px" }}
        />
      ),
      render: (text, record, index) => (
        <div className="dropdown" style={{ width: "80px" }}>
          <Tooltip title={record.proposal_status} color={tooltipColour}>
            <FormR.Select
              size="sm"
              defaultValue={record.proposal_status}
              onChange={(e) => handleProposalStatusDropdownChange(e, record)}
            >
              <option value="Planned">Planned</option>
              <option value="In Progress">In Progress</option>
              <option value="Completed">Completed</option>
              <option value="Cancelled">Cancelled</option>
              <option value="Archived">Archived</option>
            </FormR.Select>
          </Tooltip>
        </div>
      ),
    },
    {
      title: "Actions",
      render: (record) => (
        <div style={{ display: "flex" }}>
          <Tooltip
            title={"View Invoice"}
            placement="topLeft"
            color={tooltipColour}
          >
            <img
              className="delete-icon"
              src={require("./invoice.png")}
              alt="Not Found!"
              onClick={() => onTableItemNavigate(record.key + "-PROPOSAL")}
            />
          </Tooltip>
          <Tooltip title={"View Vendors"} placement="top" color={tooltipColour}>
            <img
              className="delete-icon"
              src={VendorImg}
              alt="Not Found!"
              onClick={() => onTableItemNavigate(record.key + "-VENDOR")}
            />
          </Tooltip>
          <Tooltip
            title={"Delete Invoice"}
            placement="topRight"
            color={tooltipColour}
          >
            <img
              className="delete-icon"
              src={require("./delete.png")}
              alt="Not Found!"
              onClick={() => handleDeleteProposalModalShow(record)}
            />
          </Tooltip>
        </div>
      ),
    },
  ];
  //#endregion

  //#region UI Population
  const populateUI = () => {
    setShowTable(1);
    if (loggedInUser == null) {
      console.log("emptyUser");
    }

    AxiosHelper.makeAxiosRequest(
      "Read",
      "FrequencyType",
      "GetFrequencyTypes",
      null,
      null
    )
      .then((response) => {
        let frequencyTypeOptionsArray = [];
        response.data.forEach((frequencyType) => {
          frequencyTypeOptionsArray.push({
            id: frequencyType.FreqTypeId,
            value: frequencyType.FreqTypeDescription,
          });
        });
        setFrequencyTypes(frequencyTypeOptionsArray);
        AxiosHelper.makeAxiosRequest("Read", "Home", "GetCustomers", null, null)
          .then((response) => {
            let arrCustomerIds = [];
            let customers = response.data;
            console.log("Customer Data");
            console.log(response.data);
            customers.forEach((customer) => {
              arrCustomerIds.push(customer.customerID);
            });

            const options = response.data.map((item) => {
              return { name: item.customerName, id: item.customerID };
            });

            const customerNames = [];
            const uniqueNames = new Set();

            response.data.forEach((item) => {
              const customerName = item.customerName;

              if (!uniqueNames.has(customerName)) {
                uniqueNames.add(customerName);
                customerNames.push({ text: customerName, value: customerName });
              }
            });

            options.push({ name: "-", id: -1 });
            setDropdownOptions(options);
            setCustomerFilters(customerNames);

            if (arrCustomerIds.length !== 0) {
              setShowTable(1);
            } else {
              setShowTable(1);
            }

            let searchObject = {
              customerIds: arrCustomerIds,
              proposalFilterValue: customerProposalFilterValue,
            };

            console.log(searchObject);

            AxiosHelper.makeAxiosRequest(
              "Create",
              "Home",
              "GetHomeData",
              null,
              searchObject
            )
              .then((response) => {
                let table = response.data;
                let tempProposal = {};
                let proposals = [];

                let tempProposalKeys = [];
                let tempFilters = [];
                let tempStatusFilters = [
                  {
                    text: "Planned",
                    value: "Planned",
                  },
                  {
                    text: "In Progress",
                    value: "In Progress",
                  },
                  {
                    text: "Completed",
                    value: "Completed",
                  },
                  {
                    text: "Cancelled",
                    value: "Cancelled",
                  },
                  {
                    text: "Archived",
                    value: "Archived",
                  },
                ];

                table.forEach((customer) => {
                  customer.Proposal.forEach((prop) => {
                    if (
                      tempFilters.findIndex(
                        (item) => item.value === prop.PropName
                      ) === -1
                    ) {
                      tempFilters.push({
                        text: prop.PropName,
                        value: prop.PropName,
                      });
                    }

                    let frequencyValue = "None";
                    frequencyTypeOptionsArray.forEach((frequencyType) => {
                      if (prop.PropFreqType === frequencyType.id) {
                        frequencyValue = frequencyType.value;
                      }
                    });
                    //.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',') -- add commas
                    //.replace(/(,)/g,'') -- remove commas
                    tempProposal = {
                      key: prop.PropId,
                      proposal_customer: customer.CustName,
                      proposal_name: prop.PropName,
                      proposal_date_from: prop.PropDateFrom.substring(0, 10),
                      proposal_date_to: prop.PropDateTo.substring(0, 10),
                      proposal_unit_qty: prop.PropUnitQty,
                      proposal_unit_value: prop.PropUnitValue.toFixed(2),
                      proposal_subtotal_exc: prop.PropSubTotalExc.toFixed(2),
                      proposal_subtotal_inc: prop.PropSubTotalInc.toFixed(2),
                      proposal_frequency_qty: prop.PropFreqQty,
                      proposal_frequency_type:
                        frequencyValue === "None" ? "N/A" : frequencyValue,
                      proposal_total_exc: prop.PropTotalExc.toFixed(2),
                      proposal_total_inc: prop.PropTotalInc.toFixed(2),
                      proposal_file: prop.PropFileLink,
                      proposal_status: prop.PropStatus,
                      proposal_deleted: prop.Deleted,
                      proposal_notes: prop.PropNotes,
                      prop_type: "server",
                      invHeader: [],
                    };
                    tempProposalKeys.push({
                      key: prop.PropId,
                    });
                    proposals.push(tempProposal);
                  });
                });
                setProposalFilters(tempFilters);
                setStatusFileters(tempStatusFilters);
                setDataSource(proposals);
              })
              .catch((e) => {
                console.log(e);
              });
          })
          .catch((e) => {
            console.log("ERROR!");
            console.log(e);
          });
      })
      .catch((e) => {
        console.log(e);
      });
  };

  React.useEffect(() => {
    if (!canAccessPage("Proposal")) {
      navigate("/login");
    }
    populateUI();
  }, []);
  //#endregion

  //#region Functions
  const notifySuccessful = (message) => {
    toast.success(message, {
      position: "bottom-center",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const notifyFailed = (message) => {
    toast.error(message, {
      position: "bottom-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const onChange = (page, filter, sorter) => {
    setStatusSelectedFilters(filter.proposal_status);
    setProposalSelectedFilters(filter.proposal_name);
    setCustomerSelectedFilters(filter.proposal_customer);
    setCurrentPage(page.current);
    setPageSize(page.pageSize);
  };

  const handleProposalCustomerChange = (e, row) => {
    row.proposal_customer = e.target.value;
    handleSave(row);
    onTableDataChange(true);
  };

  const handleProposalNameChange = (e, row) => {
    row.proposal_name = e.target.value;
    handleSave(row);
    onTableDataChange(true);
  };

  const handleProposalFrequencyTypeChange = (e, row) => {
    row.proposal_frequency_type = e.target.value;
    handleSave(row);
    onTableDataChange(true);
  };

  const handleProposalDateFromChange = (e, row) => {
    row.proposal_date_from = e.target.value;
    handleSave(row);
    onTableDataChange(true);
  };

  const handleProposalDateToChange = (e, row) => {
    row.proposal_date_to = e.target.value;
    handleSave(row);
    onTableDataChange(true);
  };

  const calculateColumns = (row) => {
    row.proposal_subtotal_exc = (
      row.proposal_unit_qty * row.proposal_unit_value
    ).toFixed(2);
    row.proposal_subtotal_inc = (
      row.proposal_unit_qty *
      row.proposal_unit_value *
      1.15
    ).toFixed(2);
    row.proposal_total_exc = (
      row.proposal_subtotal_exc * row.proposal_frequency_qty
    ).toFixed(2);
    row.proposal_total_inc = (
      row.proposal_subtotal_exc *
      row.proposal_frequency_qty *
      1.15
    ).toFixed(2);
  };

  const handleProposalUnitQtyChange = (e, row) => {
    row.proposal_unit_qty = e.target.value;
    calculateColumns(row);
    handleSave(row);
    onTableDataChange(true);
  };

  const handleProposalUnitValueChange = (e, row) => {
    row.proposal_unit_value = e.target.value;
    calculateColumns(row);
    handleSave(row);
    onTableDataChange(true);
  };

  const handleProposalFrequencyQty = (e, row) => {
    row.proposal_frequency_qty = e.target.value;
    calculateColumns(row);
    handleSave(row);
    onTableDataChange(true);
  };

  const handleProposalStatusDropdownChange = (e, row) => {
    row.proposal_status = e.target.value;
    handleSave(row);
    onTableDataChange(true);
  };

  const handleSave = (row) => {
    console.log(row);
    for (const key in row) {
      let keyValue = String(row[key]);

      switch (key) {
        case "proposal_customer":
          if (!keyValue.replace(/\s/g, "").length) {
            row[key] = "-";
          }
          break;

        case "proposal_name":
          if (!keyValue.replace(/\s/g, "").length) {
            row[key] = "-";
          }
          break;

        case "proposal_date_from":
          if (!keyValue.replace(/\s/g, "").length) {
            row[key] = "-";
          }
          break;

        case "proposal_date_to":
          if (!keyValue.replace(/\s/g, "").length) {
            row[key] = "-";
          }
          break;

        case "proposal_unit_qty":
          if (!keyValue.replace(/\s/g, "").length) {
            row[key] = "0";
          }
          break;

        case "proposal_unit_value":
          if (!keyValue.replace(/\s/g, "").length) {
            row[key] = "0";
          }
          break;

        case "proposal_subtotal_exc":
          if (!keyValue.replace(/\s/g, "").length) {
            row[key] = "0";
          }
          break;

        case "proposal_subtotal_inc":
          if (!keyValue.replace(/\s/g, "").length) {
            row[key] = "0";
          }
          break;

        case "cproposal_frequency_qty":
          if (!keyValue.replace(/\s/g, "").length) {
            row[key] = "0";
          }
          break;

        case "proposal_frequency_type":
          if (!keyValue.replace(/\s/g, "").length) {
            row[key] = "-";
          }
          break;

        case "proposal_total_exc":
          if (!keyValue.replace(/\s/g, "").length) {
            row[key] = "0";
          }
          break;
        case "proposal_total_inc":
          if (!keyValue.replace(/\s/g, "").length) {
            row[key] = "0";
          }
          break;
        case "proposal_file":
          if (!keyValue.replace(/\s/g, "").length) {
            row[key] = "-";
          }
          break;
        case "proposal_status":
          if (!keyValue.replace(/\s/g, "").length) {
            row[key] = "-";
          }
          break;
        default:
          break;
      }
    }

    const newData = [...tableDataSource];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setDataSource(newData);
  };

  const notifyChanges = (message) => {
    toast.warning(message, {
      toastId: "ToastDataTableWarning",
      position: "top-right",
      autoClose: false,
      closeOnClick: true,
      draggable: false,
      progress: undefined,
      closeButton: true,
    });
  };

  function onTableDataChange(isDirty) {
    if (isDirty) {
      notifyChanges("Data table contains unsaved changes.");
    } else {
      toast.dismiss();
    }
  }

  const handleEditNotesShowModalClose = () => {
    setEditNotesShow(false);
  };

  const handleEditNotesModalShow = () => {
    setEditNotesShow(true);
  };

  const onEditNotes = (proposal) => {
    setSelectedNotes(proposal);
    setNewSelectedNotes(proposal.proposal_notes);
    handleEditNotesModalShow();
  };

  const onEditNotesModalSave = () => {
    console.log(selectedNotes.proposal_notes);
    console.log(newSelectedNotes);
    if (selectedNotes.proposal_notes === newSelectedNotes) {
      handleEditNotesShowModalClose();
      notifySuccessful("No changes have been made.");
    } else {
      selectedNotes.proposal_notes = newSelectedNotes;
      handleSave(selectedNotes);
      onTableDataChange(true);
      handleEditNotesShowModalClose();
      notifySuccessful("Changes have been made!");
    }
  };

  const handleEditDocumentLinkModalClose = () => {
    setEditDocumentLinkShow(false);
  };

  const handleEditDocumentLinkModalShow = () => {
    setEditDocumentLinkShow(true);
  };

  const onEditDocumentLink = (proposal) => {
    setSelectedDocumentLink(proposal);
    setNewSelectedDocumentLink(proposal.proposal_file);
    handleEditDocumentLinkModalShow();
  };

  const onEditDocumentLinkModalSave = () => {
    if (selectedDocumentLink.proposal_file === newSelectedDocumentLink) {
      handleEditDocumentLinkModalClose();
      notifySuccessful("No changes have been made");
    } else {
      selectedDocumentLink.proposal_file = newSelectedDocumentLink;
      handleSave(selectedDocumentLink);
      onTableDataChange(true);
      handleEditDocumentLinkModalClose();
      notifySuccessful("Changes have been made!");
    }
  };

  function onTableItemNavigate(detail) {
    // setTimeout(() => {
    Navigate(detail);
    // }, 2000);
  }

  function Navigate(detail) {
    if (detail.includes("CUSTOMER")) {
      navigate("/customer", { state: detail });
    }

    if (detail.includes("INVOICE")) {
      navigate("/InvoiceHeader", { state: detail });
    }

    if (detail.includes("PROPOSAL")) {
      navigate("/proposal", { state: detail });
    }

    if (detail.includes("VENDOR")) {
      navigate("/vendorCost", { state: detail });
    }
  }

  const handleDeleteProposalModalClose = () =>
    setDeleteProposalModalShow(false);

  const onCancelChanges = () => {
    //ViewCustomers();
    populateUI();
    onTableDataChange(false);
    notifySuccessful("Changes Successfully Cleared!");
    handleCancelModalClose();
  };

  const handleCancelModalClose = () => {
    setCancelModalShow(false);
  };

  const handleCancelModalShow = () => {
    setCancelModalShow(true);
  };

  function GetNewRowKey(listItems) {
    let biggestKey = 0;
    listItems.forEach((element) => {
      if (element.key > biggestKey) {
        biggestKey = element.key;
      }
    });
    biggestKey = biggestKey + 1;
    return biggestKey;
  }

  const handleProposalAdd = () => {
    onTableDataChange(true);
    let newRowKey = GetNewRowKey(tableDataSource);
    const newData = {
      key: newRowKey,
      proposal_customer: "-",
      proposal_user_id: loggedInUser.userId,
      proposal_name: "-",
      proposal_date_from: "-",
      proposal_date_to: "-",
      proposal_unit_qty: 0,
      proposal_unit_value: 0.0,
      proposal_subtotal_exc: 0,
      proposal_subtotal_inc: 0,
      proposal_frequency_qty: 0,
      proposal_frequency_type: "Once Off",
      proposal_total_exc: 0,
      proposal_total_inc: 0,
      proposal_file: null,
      proposal_status: "In Progress",
      prop_type: "client",
      invHeader: [],
    };
    const newLines = [...tableDataSource];
    newLines.push(newData);
    setDataSource(newLines);
    //calculate focus page in table
    let tempCurrentPage = Math.floor(newLines.length / pageSize) + 1;
    console.log(console.log(newLines.length));
    console.log(pageSize);
    setCurrentPage(tempCurrentPage);
  };

  function validation() {
    let valid = true;
    tableDataSource.forEach((proposal) => {
      if (
        proposal.proposal_name === "-" ||
        parseFloat(proposal.proposal_unit_value) <= 0 ||
        parseInt(proposal.proposal_unit_qty) <= 0 ||
        parseInt(proposal.proposal_frequency_qty) <= 0 ||
        proposal.proposal_date_to === "-" ||
        proposal.proposal_date_from === "-"
      ) {
        valid = false;
      }
    });
    return valid;
  }

  const SaveTable = () => {
    try {
      let tempProposal = {};
      let fCustomer = false;
      let fFrequency = false;

      if (validation()) {
        tableDataSource.forEach((proposal) => {
          let customerDropdown = dropdownOptions.find(
            (cust) => cust.name === proposal.proposal_customer
          );
          let fError = false;
          if (
            customerDropdown === undefined ||
            customerDropdown == null ||
            proposal.proposal_customer === "-"
          ) {
            fCustomer = true;
            fError = true;
          }
          let customerId = customerDropdown.id;
          console.log(frequencyTypes);
          console.log(proposal.proposal_frequency_type);
          let frequencyId = frequencyTypes.find(
            (freq) => freq.value === proposal.proposal_frequency_type
          ).id;

          if (!fError) {
            if (proposal.prop_type === "server") {
              tempProposal = {
                PropId: proposal.key,
                CustId: customerId,
                PropName: proposal.proposal_name,
                PropDateFrom: proposal.proposal_date_from,
                PropDateTo: proposal.proposal_date_to,
                PropUnitQty: parseInt(proposal.proposal_unit_qty),
                PropUnitValue: parseFloat(proposal.proposal_unit_value),
                PropSubTotalExc: parseFloat(proposal.proposal_subtotal_exc),
                PropSubTotalInc: parseFloat(proposal.proposal_subtotal_inc),
                PropFreqQty: parseInt(proposal.proposal_frequency_qty),
                PropFreqType: frequencyId,
                PropTotalExc: parseFloat(proposal.proposal_total_exc),
                PropTotalInc: parseFloat(proposal.proposal_total_inc),
                PropNotes: proposal.proposal_notes,
                PropStatus: proposal.proposal_status,
                PropFileLink: proposal.proposal_file,
              };
              console.log("This is the loggedInUser:");
              console.log(loggedInUser);
              AxiosHelper.makeAxiosRequest(
                "Create",
                "Proposal",
                "UpdateProposal",
                { currentUserId: loggedInUser },
                tempProposal
              )
                .then(() => {
                  populateUI();
                })
                .catch((Error) => {
                  if (Error === "ValidationError") {
                    console.log(Error);
                  }
                  console.log(Error);
                  notifyFailed("An Error Occurred, Please Try Again.");
                });
            } else {
              tempProposal = {
                CustId: customerId,
                PropName: proposal.proposal_name,
                PropDateFrom: proposal.proposal_date_from,
                PropDateTo: proposal.proposal_date_to,
                PropUnitQty: parseInt(proposal.proposal_unit_qty),
                PropUnitValue: parseFloat(proposal.proposal_unit_value),
                PropSubTotalExc: parseFloat(proposal.proposal_subtotal_exc),
                PropSubTotalInc: parseFloat(proposal.proposal_subtotal_inc),
                PropFreqQty: parseInt(proposal.proposal_frequency_qty),
                PropFreqType: frequencyId,
                PropTotalExc: parseFloat(proposal.proposal_total_exc),
                PropTotalInc: parseFloat(proposal.proposal_total_inc),
                PropNotes: proposal.proposal_notes,
                PropStatus: proposal.proposal_status,
                PropFileLink: proposal.proposal_file,
              };
              AxiosHelper.makeAxiosRequest(
                "Create",
                "Proposal",
                "CreateNewProposal",
                { currentUserId: loggedInUser },
                tempProposal
              )
                .then((response) => {
                  notifySuccessful("Proposal Created!");
                  populateUI();
                })
                .catch((error) => {
                  console.log(error);
                  if (error.message === "Network Error") {
                    notifyFailed("A Network Error Occured, Please Try Again.");
                  } else {
                    notifyFailed("An Error Occured, Please Try Again.");
                  }
                });
            }
          }
        });
        onTableDataChange(false);

        if (fCustomer) {
          notifyFailed("Please select a customer for the proposal");
        }
        if (!fCustomer && !fFrequency) {
          notifySuccessful("Changes saved!");
        }
      } else {
        notifyFailed("Please complete proposals");
      }
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  };

  function handleDeleteProposalModalShow(proposal) {
    setSelectedDeleteProposal(proposal);
    setDeleteProposalModalShow(true);
  }
  function NavigateToLogin() {
    navigate("/login");
  }

  function onProposalDelete(deleteProposal) {
    let proposalDataCopy = [...tableDataSource];
    let deleteProposalIndex = proposalDataCopy.findIndex(
      (x) => x.key === deleteProposal.key
    );

    if (deleteProposal.prop_type === "server") {
      AxiosHelper.makeAxiosRequest(
        "Delete",
        "Proposal",
        "DeleteProposal",
        { proposalId: deleteProposal.key, currentUserId: loggedInUser.userId },
        null
      )
        .then((response) => {
          if (response.data === "") {
            proposalDataCopy.splice(deleteProposalIndex, 1);
            setDataSource(proposalDataCopy);
            notifySuccessful("Proposal Deleted!");
            handleDeleteProposalModalClose();
          } else {
            notifyFailed("Proposal has invoices loaded.");
            handleDeleteProposalModalClose();
          }
        })
        .catch((error) => {
          console.log(error);
          notifyFailed("An Error Occurred, Please Try Again.");
          handleDeleteProposalModalClose();
        });
    } else {
      if (deleteProposal.invHeader.length > 0) {
        notifyFailed("Invoice has invoice lines loaded.");
        handleDeleteProposalModalClose();
      } else {
        proposalDataCopy.splice(deleteProposalIndex, 1);
        setDataSource(proposalDataCopy);
        notifySuccessful("Proposal Deleted!");
        handleDeleteProposalModalClose();
      }
    }
  }

  //#endregion

  return (
    <div>
      {/* Proposal Delete Modal */}

      <Modal
        centered
        show={deleteProposalModalShow}
        onHide={handleDeleteProposalModalClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Proposal</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div>
              <p className="p-main">
                Are you sure you want to delete the following proposal?
                <br />
                This change can not be reversed.
              </p>
            </div>
            <div>
              <p className="p-main">{selectedDeleteProposal.proposal_name}</p>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" onClick={handleDeleteProposalModalClose}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => onProposalDelete(selectedDeleteProposal)}
          >
            Delete Proposal
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Confirm edit or notes Modal*/}
      <Modal
        centered
        show={editNotesShow}
        onHide={handleEditNotesShowModalClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Notes</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div style={{ justifyContent: "space-around" }}>
            <h6 style={{ textAlign: "center" }}>Notes:</h6>
            <FormR.Control
              id="EditProposalNotes"
              type="text"
              as="input"
              defaultValue={selectedNotes.proposal_notes}
              style={{ margin: "auto", maxWidth: "90%" }}
              onBlur={(e) => {
                if (!(e.target.value === "-")) {
                  setNewSelectedNotes(e.target.value);
                }
              }}
            />
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" onClick={handleEditNotesShowModalClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={onEditNotesModalSave}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Confirm edit or document link Modal*/}
      <Modal
        centered
        show={editDocumentLinkShow}
        onHide={handleEditDocumentLinkModalClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Document Link</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <h6 style={{ marginTop: "auto" }}>Document Link:</h6>
            <FormR.Control
              id="EditProposalDocumentLink"
              type="text"
              defaultValue={selectedDocumentLink.proposal_file}
              style={{ maxWidth: "fit-content" }}
              onBlur={(e) => {
                if (!(e.target.value === "-")) {
                  setNewSelectedDocumentLink(e.target.value);
                }
              }}
            />
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" onClick={handleEditDocumentLinkModalClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={onEditDocumentLinkModalSave}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Confirm Customer Cancel Modal */}

      <Modal centered show={cancelModalShow} onHide={handleCancelModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Clear Changes</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div>
              <p className="p-main">
                Are you sure you want to clear any changes made?
                <br />
                This does not include items that have been deleted.
              </p>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" onClick={handleCancelModalClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={onCancelChanges}>
            Clear Changes
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer />
      {shouldLogIn === true && (
        <div>
          <h1>Please log in to use this application</h1>
          <Button
            onClick={NavigateToLogin}
            variant="primary"
            className="login-button"
          >
            Login
          </Button>
        </div>
      )}
      <NavBar />
      <div id="home-body">
        <h1 style={{ marginTop: "30px" }}>Proposals</h1>
        <div></div>

        {showtable === 0 && (
          <div id="home-no-data">
            <h2 style={{ color: "#b0b0b0" }}>Select Customer(s) To View</h2>
          </div>
        )}

        {showtable === 1 && (
          <div className="row">
            <div className={tableSize}>
              <div id="home-table-container">
                <Table
                  id="home-table"
                  pagination={{
                    position: ["bottomCenter"],
                    //showSizeChanger: true,
                    defaultPageSize: pageSize,
                    current: currentPage,
                    hideOnSinglePage: true,
                    pageSizeOptions: [5, 10, 20, 50, 100],
                  }}
                  bordered="true"
                  components={components}
                  columns={ProposalColumns}
                  dataSource={tableDataSource}
                  onChange={onChange}
                  rowClassName="row-class-test"
                  footer={() => (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>
                        <Button onClick={handleProposalAdd}>Add</Button>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "right",
                          gap: "20px",
                        }}
                      >
                        <Button
                          variant="danger"
                          onClick={handleCancelModalShow}
                        >
                          Clear Changes
                        </Button>
                        <Button onClick={SaveTable} variant="success">
                          Save Changes
                        </Button>
                      </div>
                    </div>
                  )}
                ></Table>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
export default Home;
